// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const common_environment = {
  production: false,
  user: {
    api_base_url: 'https://user-qa.delivergate.com'
  },
  delivery: {
    api_base_url: 'https://platform-qa.delivergate.com'
  },
  pos: {
    api_base_url: 'https://pos-qa.delivergate.com'
  },
  report: {
    api_base_url: 'https://reporting-qa.delivergate.com'
  },
  admin: {
    api_base_url: 'https://admin-qa.delivergate.com'
  },
  webshop: {
    api_base_url: 'https://webshop-qa.delivergate.com'
  },
  reservation: {
    api_base_url: 'https://reservation-qa.delivergate.com'
  },

  CLIENT_ID: 1,
  CLIENT_SECRET: 'Q2qHmKvtE30AVkQakUTGnP60MynZCctTCOxyFdfS',
  GRANT_TYPE: 'password',
  currency: '£',
  currency_text: 'Pound',
  currency_logo: 'pound.png',

  firebase: {
    apiKey: "AIzaSyBx9cVkCe4fWjkaGl-Jbk6gsSxvFJ8PWLM",
    authDomain: "delivergate-qa.firebaseapp.com",
    projectId: "delivergate-qa",
    storageBucket: "delivergate-qa.appspot.com",
    messagingSenderId: "576915947788",
    appId: "1:576915947788:web:ee16a099153f3308e08929",
    measurementId: "G-SQ3R8BGFRH"
  },

  app_version: 'v 2.1.3'
};
